// register.js — adapter "dash v2" (R4, design §10): RI-registra il Cruscotto con
// version:2 + submenu:'shell' + nav[] (upgrade B2.9 sopra la register v1 di
// dashboard-module.js:355). Il Cruscotto è UNA pagina senza tab interne: le voci
// sono le sue SEZIONI reali (KPI, calendario, agenda, task) e navigate() scorre
// alla sezione via window.__dashShellNav (hook additivo in coda al file modulo).
//
// GUARDIA KILL-SWITCH (come proc-v0): sotto workspace-host (shell 404) resta INERTE.
// FALLBACK per-modulo:
//  - localStorage.shell_submenu_dash='0' (+reload) ⇒ submenu:'internal' istantaneo;
//  - hook assente (file modulo vecchio) o modulo mai registrato ⇒ adapter inerte:
//    il modulo resta v1 con la sua resa. Nessuna nav interna da nascondere:
//    il Cruscotto non ha tab/toolbar di navigazione propria.

import { moduleSubmenuEnabled } from '../shell/flags.js';
import { label } from '../shell/glossary.js';

export const DASH_NAV = [
  {
    section: 'dash.section.overview',
    items: [
      { id: 'kpi', glossKey: 'dash.kpi', badge: null, adminOnly: false },
      { id: 'calendar', glossKey: 'dash.calendar', badge: null, adminOnly: false },
      { id: 'agenda', glossKey: 'dash.agenda', badge: null, adminOnly: false },
      { id: 'tasks', glossKey: 'dash.tasks', badge: null, adminOnly: false },
    ],
  },
];

export function installDashV2(win) {
  const W = win.Workspaces;
  if (!W || W.version !== 2 || typeof W.navigate !== 'function' || !W.bus) return false;
  if (typeof win.__dashShellNav !== 'function') return false; // modulo senza hook: resta v1
  if (typeof W.has !== 'function' || !W.has('dash')) return false; // mai upgrade orfano
  W.register({
    id: 'dash',
    version: 2,
    submenu: moduleSubmenuEnabled(win, 'dash') ? 'shell' : 'internal',
    nav: DASH_NAV,
    navigate: (itemId) => {
      if (win.__dashShellNav(itemId) !== true) {
        W.bus.emit('toast', { kind: 'error', msg: label('shell.bridge.missing') + itemId });
      }
    },
    openDeepLink: (l) => !!(l && typeof l.item === 'string' && win.__dashShellNav(l.item) === true),
  });
  return true;
}

// side-effect SOLO nel browser (i contract test importano il file sotto node)
if (typeof window !== 'undefined') installDashV2(window);
